import { z } from 'zod';
import { validators } from '@huspy/forge/shared';

const { textFieldValidator, phoneNumberValidator } = validators;

export const createLeadSchema = z.object({
  name: textFieldValidator,
  phone: phoneNumberValidator,
  city: textFieldValidator,
  marketType: textFieldValidator,
  budget: textFieldValidator,
  community: textFieldValidator,
});
